/**
 * stripUrlQuery — drop the query string and fragment from a URL or asset path.
 *
 * Asset paths in this app are not always relative: `buildNodeAssetDownloadBaseUrl`
 * passes absolute URLs straight through, so an "asset path" can be a presigned
 * GCS / R2 / legacy-Supabase URL whose query string IS the credential
 * (`X-Goog-Signature`, `Signature` + `Key-Pair-Id`, Supabase `token`). Anything
 * holding that query string can read the object, so it must never reach a log
 * sink, an error message, or telemetry. The path alone is what makes the entry
 * useful for debugging; the signature is pure liability.
 *
 * Deliberately a plain truncation rather than `new URL(...)` normalization: a
 * relative asset path (`images/characters/hero/v1.jpg`) must survive verbatim,
 * and URL parsing would rewrite it against the page origin. A query string
 * cannot begin before the path ends, so truncating at the first `?` or `#` is
 * exact for absolute URLs too — and total, with no unparseable-input branch.
 */
export function stripUrlQuery(url: string): string {
  const cut = url.search(/[?#]/)
  return cut === -1 ? url : url.slice(0, cut)
}
